import React, { type FC } from "react";

import { IconCloseOutlined } from "~/components/icon";
import { Logo } from "~/components/logo";

import { useNavigateToLink } from "../../components/react/link";
import { Tooltip } from "../../components/react/tooltip/Tooltip";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export interface MainMenuHeaderProps {
	onClose: () => void;
}

export const MainMenuHeader: FC<MainMenuHeaderProps> = ({ onClose }) => {
	const navigateTo = useNavigateToLink("/", {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			className="h-10 bg-primary-600 hover:cursor-pointer"
			extra={
				<Tooltip placement="bottom" title="Close">
					<IconCloseOutlined
						className="relative z-1 mr-1 flex text-base text-white opacity-50 hover:opacity-100"
						data-testid="icon-close"
						onClick={(event) => {
							event.preventDefault();
							onClose();
						}}
					/>
				</Tooltip>
			}
			label={<Logo className="mt-[3px]" size="xs" variant="negate-mono" />}
			to={navigateTo}
		/>
	);
};
